<template>
  <button
    class="text-xl font-medium text-brand text-nowrap"
    @click="openCreateIframe"
  >
    + {{ $t('b2b|header|button|create') }}
  </button>

  <modal-create-iframe v-model="showCreateIframe" />
</template>

<script setup>
import { ref } from 'vue'
import ModalCreateIframe from '@/widgets/ModalCreateIframe/ui/ModalCreateIframe.vue'
import segmentService from '@/shared/services/segment.service'
import { ANALYTICS_EVENT_TYPE } from '@/packages/auth-service/requiredUserAction/shared/utils/analytics'

const showCreateIframe = ref(false)

function openCreateIframe() {
  segmentService.trackNewEvent(ANALYTICS_EVENT_TYPE.CLICK, {
    event: ANALYTICS_EVENT_TYPE.CLICK,
    page: 'earn_on_swap',
    screen: 'earn_on_swap',
    button_name: 'create_swap_link',
  })
  showCreateIframe.value = true
}
</script>
